import { Plus } from "lucide-react";
import { BackendButton } from "./backend-ui";
import type { ReactNode } from "react";

type BackendListHeaderPropsT = {
  title: string;
  /** Plain string or responsive markup (e.g. shorter label on mobile). */
  buttonText?: ReactNode;
  onButtonClick?: () => void;
  buttonHref?: string;
  children?: ReactNode;
};

export function BackendListHeader({
  title,
  buttonText,
  onButtonClick,
  buttonHref,
  children,
}: BackendListHeaderPropsT) {
  const buttonProps = buttonHref
    ? {
        asChild: true,
        children: (
          <a href={buttonHref}>
            <Plus />
            {buttonText}
          </a>
        ),
      }
    : {
        onClick: onButtonClick,
        children: (
          <>
            <Plus />
            {buttonText}
          </>
        ),
      };

  return (
    <div className="flex items-center justify-between gap-3 pt-4">
      <h1 className="text-[32px] leading-tight font-semibold">{title}</h1>
      {(buttonText || children) && (
        <div className="flex items-center gap-3">
          {children}
          {buttonText && <BackendButton variant="default" {...buttonProps} />}
        </div>
      )}
    </div>
  );
}
